export function getHasListingBoardCardCoverImage({
  coverThumbUrl,
  failedCoverUrl,
}) {
  return Boolean(coverThumbUrl) && failedCoverUrl !== coverThumbUrl
}
